export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
  }
}

export class SumupUnitResult {
  name: string
  score: number
  allot: number
  total_rank: number
  total_std_score: number
  total_avg_score: number
  total_max_score: number
  total_min_score: number
  total_examinee_count: number
  gender_rank: number
  gender_std_score: number
  gender_avg_score: number
  gender_max_score: number
  gender_min_score: number
  gender_examinee_count: number

  constructor(x: any){
    this.name = x.name;
    this.score = x.score
    this.allot = x.allot;
    this.total_rank = x.total_rank;
    this.total_std_score = x.total_std_score?.toFixed(1);
    this.total_avg_score = x.total_avg_score?.toFixed(1);
    this.total_max_score = x.total_max_score;
    this.total_min_score = x.total_min_score;
    this.total_examinee_count = x.total_examinee_count;
    this.gender_rank = x.gender_rank;
    this.gender_std_score = x.gender_std_score?.toFixed(1);
    this.gender_avg_score = x.gender_avg_score?.toFixed(1);
    this.gender_max_score = x.gender_max_score;
    this.gender_min_score = x.gender_min_score;
    this.gender_examinee_count = x.gender_examinee_count;
  }
}

export class SumupPart1Result {
  part1: string
  question_content: string
  score: number
  allot: number
  score_rate: number
  total_avg_score: number
  total_score_rate: number
  gender_avg_score: number
  gender_score_rate: number

  constructor(x: any){
    this.part1 = x.part1;
    this.question_content = x.question_content;
    this.score = x.score
    this.allot = x.allot;
    this.score_rate = x.score_rate?.toFixed(1);
    this.total_avg_score = x.total_avg_score?.toFixed(1);
    this.gender_avg_score = x.gender_avg_score?.toFixed(1);
    this.total_score_rate = x.total_score_rate?.toFixed(0);
    this.gender_score_rate = x.gender_score_rate?.toFixed(0);
  }
}

export class SumupFieldResult {
  part1: string
  part2: string
  part3: string
  question_content: string
  score: number
  allot: number
  total_score_rate: number
  gender_score_rate: number
  correct_state: number

  constructor(x: any){
    this.part1 = x.part1;
    this.part2 = x.part2;
    this.part3 = x.part3;
    this.question_content = x.question_content;
    this.score = x.score
    this.allot = x.allot;
    this.total_score_rate = x.total_score_rate?.toFixed(1);
    this.gender_score_rate = x.gender_score_rate?.toFixed(1);
    this.correct_state = x.correct_state;
  }
}